import { useEffect, useState } from "react";
import api from "../api/adminApi";
import AdminLayout from "./AdminLayout";

export default function CursosAdmin() {
  const [cursos, setCursos] = useState([]);
  const [profesores, setProfesores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imagen, setImagen] = useState(null);
  const [editandoId, setEditandoId] = useState(null);

  const [form, setForm] = useState({
    nombre: "",
    descripcion: "",
    precio: "",
    profesor_id: "",
    link_clase: "",
    fecha_clase: "",
  });

  /* =============================
     FORMATEAR FECHA (ADMIN)
  ============================== */
  const formatFechaAdmin = (fecha) => {
    if (!fecha) return "—";

    const date = new Date(fecha);

    return date.toLocaleString("es-CL", {
      timeZone: "America/Santiago",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  /* =============================
     CARGAR DATOS
  ============================== */
  const loadData = async () => {
    try {
      const cursosRes = await api.get("/cursos");
      const profesRes = await api.get("/profesores");

      setCursos(cursosRes.data);
      setProfesores(profesRes.data);
    } catch (error) {
      console.error("Error cargando datos", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  /* =============================
     MANEJADORES
  ============================== */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* =============================
     CREAR / EDITAR CURSO
  ============================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("nombre", form.nombre);
    formData.append("descripcion", form.descripcion);
    formData.append("precio", form.precio);
    formData.append("profesor_id", form.profesor_id || "");
    formData.append("link_clase", form.link_clase || "");
    formData.append("fecha_clase", form.fecha_clase || "");

    if (imagen) formData.append("imagen", imagen);

    try {
      if (editandoId) {
        await api.put(`/cursos/${editandoId}`, formData);
        alert("Curso actualizado");
      } else {
        await api.post("/cursos", formData);
        alert("Curso creado");
      }

      setForm({
        nombre: "",
        descripcion: "",
        precio: "",
        profesor_id: "",
        link_clase: "",
        fecha_clase: "",
      });

      setImagen(null);
      setEditandoId(null);
      loadData();

    } catch (error) {
      console.error(error);
      alert("Error al guardar curso");
    }
  };

  /* =============================
     ELIMINAR CURSO
  ============================== */
  const eliminarCurso = async (id) => {
    if (!window.confirm("¿Eliminar este curso?")) return;

    try {
      await api.delete(`/cursos/${id}`);
      alert("Curso eliminado");
      loadData();
    } catch (error) {
      console.error(error);
      alert("Error al eliminar curso");
    }
  };

  /* =============================
     EDITAR CURSO
  ============================== */
  const editarCurso = (curso) => {
    setForm({
      nombre: curso.nombre,
      descripcion: curso.descripcion,
      precio: curso.precio,
      profesor_id: curso.profesor_id || "",
      link_clase: curso.link_clase || "",
      fecha_clase: curso.fecha_clase
        ? new Date(curso.fecha_clase).toISOString().slice(0, 16)
        : "",
    });
    setEditandoId(curso.id);
  };

  /* =============================
     RENDER
  ============================== */
  return (
    <AdminLayout>
      <h1>Gestión de Cursos</h1>

      {/* ================= FORMULARIO ================= */}
      <form onSubmit={handleSubmit} className="admin-form">
        <h3>Crear / Editar Curso</h3>

        <div className="form-grid">
          <div className="form-group">
            <label>Nombre del curso</label>
            <input
              type="text"
              name="nombre"
              value={form.nombre}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Precio</label>
            <input
              type="number"
              name="precio"
              value={form.precio}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group full">
            <label>Descripción</label>
            <textarea
              name="descripcion"
              value={form.descripcion}
              onChange={handleChange}
              rows="4"
            />
          </div>

          <div className="form-group">
            <label>Profesor</label>
            <select
              name="profesor_id"
              value={form.profesor_id}
              onChange={handleChange}
            >
              <option value="">Sin profesor</option>
              {profesores.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.nombre}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Link de la clase (Zoom / Meet)</label>
            <input
              type="text"
              name="link_clase"
              value={form.link_clase}
              onChange={handleChange}
              placeholder="https://meet.google.com/xxxx"
            />
          </div>

          <div className="form-group">
            <label>Fecha y hora de la clase</label>
            <input
              type="datetime-local"
              name="fecha_clase"
              value={form.fecha_clase}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Imagen del curso</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImagen(e.target.files[0])}
            />
          </div>
        </div>

        {imagen && (
          <div className="image-preview">
            <img src={URL.createObjectURL(imagen)} alt="Preview" />
          </div>
        )}

        <button type="submit" className="btn-primary">
          {editandoId ? "Actualizar curso" : "Guardar curso"}
        </button>
      </form>

      <hr />

      {/* ================= TABLA ================= */}
      {loading ? (
        <p>Cargando cursos...</p>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Precio</th>
              <th>Imagen</th>
              <th>Descripción</th>
              <th>Profesor</th>
              <th>Link clase</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {cursos.length === 0 ? (
              <tr>
                <td colSpan="8">No hay cursos</td>
              </tr>
            ) : (
              cursos.map((c) => (
                <tr key={c.id}>
                  <td>{c.nombre}</td>
                  <td>${c.precio}</td>
                  <td>
                    {c.imagen ? (
                      <img
                      src={`https://centromillennials.com/uploads/${c.imagen}`}
                      alt={c.nombre}
                    />
                    ) : (
                      "Sin imagen"
                    )}
                  </td>
                  <td>{c.descripcion || "—"}</td>
                  <td>{c.profesor_nombre || "Sin asignar"}</td>
                  <td>{c.link_clase || "Sin link"}</td>
                  <td>{formatFechaAdmin(c.fecha_clase)}</td>
                  <td>
                    <button onClick={() => editarCurso(c)}>Editar</button>
                    <button onClick={() => eliminarCurso(c.id)}>Eliminar</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </AdminLayout>
  );
}
